import { writable } from "svelte/store";

function saveTheme() {
  let theme = localStorage.getItem("theme");
  if (theme) {
    theme = JSON.parse(theme);
    if (theme === "dark") document.body.classList.add("theme-dark");
  } else {
    theme = "light";
  }

  const { subscribe, set } = writable(theme);

  return {
    subscribe,
    set: (theme) => {
      localStorage.setItem("theme", theme ? JSON.stringify(theme) : "light");
      if (theme === "dark") {
        document.body.classList.add("theme-dark");
      } else {
        document.body.classList.remove("theme-dark");
      }
      set(theme);
    }
  };
}

export default saveTheme();
